import React from 'react'

import PerilakuKerja from 'app/KinerjaPage/pages/Pelaksanaan/PerilakuKerja'
import KinerjaLayout from 'app/KinerjaShared/components/KinerjaLayout'
import { TOGGLE_KEYS } from 'configs/toggle-feature'
import { getServerSidePropsWithToggle } from 'utils/toggle.server'
import { PageGuardPelaksanaanDate } from 'app/KinerjaPage/pages/PelaksanaanV2/components/PageGuardPelaksanaanDate'

import type { TToggleKeyValuePair } from 'configs/toggle-feature'
import type { NextPageContext } from 'next'

export const getServerSideProps = getServerSidePropsWithToggle({
  toggleKeys: TOGGLE_KEYS.filter((key) => key.includes('kinerja')),
  serverProps: async (
    _context: NextPageContext,
    toggle: TToggleKeyValuePair
  ) => {
    const isKinerjaEnabled = toggle?.['kinerja-enabled'] || false
    const isKinerjaPelaksanaanEnabled =
      toggle?.['kinerja-pelaksanaan-enabled'] || false

    if (!isKinerjaEnabled || !isKinerjaPelaksanaanEnabled) {
      return {
        redirect: {
          destination: '/404',
          permanent: false,
        },
      }
    }

    return { props: {} }
  },
})

const HasilKerjaUtama = () => {
  return (
    <PageGuardPelaksanaanDate>
      <PerilakuKerja />
    </PageGuardPelaksanaanDate>
  )
}

HasilKerjaUtama.Layout = KinerjaLayout

HasilKerjaUtama.layoutOpts = {
  hasHeader: true,
}

export default HasilKerjaUtama
